<!--
 * @Version: 1.0
 * @Autor: wenruihuan
 * @Date: 2022-04-01 00:42:30
 * @LastEditors: myname
 * @LastEditTime: 2022-04-03 12:52:09
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',

  created() {
  },
}
</script>

<style>
#app {

  overflow: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  //color: #2c3e50;
  background: url("./assets/images/index_bg1.png");
  //background-color: #f5f6fa;
}
.el-table--border, .el-table--group{
  border: #938C8C79 solid 1px !important;
}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  /*border-right: #938C8C79 solid 1px !important;*/
  /*border-bottom: #938C8C79 solid 1px !important;*/
  border: #938C8C79 solid 1px !important;
}
.el-checkbox__inner{
  border: #938C8C79 solid 2px !important;
}
/* 全局样式 */
.el-tooltip__popper {
  max-width: 1200px !important;
  word-break: break-all;
}

.el-tooltip__popper .popper__arrow {
  display: block;
}

</style>
